import { render } from "./copyTraders.vue?vue&type=template&id=3b0bce95"
import script from "./copyTraders.vue?vue&type=script&lang=js"
export * from "./copyTraders.vue?vue&type=script&lang=js"

import "./copyTraders.vue?vue&type=style&index=0&id=3b0bce95&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__